<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <textarea  class="form-control" [formControlName]="field.name" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}"></textarea>

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>

</div>
